/**
 * Directory design tokens.
 *
 * Centralises the tiny set of layout constants the Directory pages
 * repeat (page padding, section gap, row height, action-column width,
 * corner radius). Colors come from the MUI theme — we do NOT introduce
 * a competing palette here.
 *
 * Consumers spread these into `sx` props, e.g.
 *
 *   <Box sx={{ px: dirTokens.page.px, py: dirTokens.page.py, maxWidth: dirTokens.page.maxWidth }}>
 *   <TableRow sx={{ height: dirTokens.table.rowHeight }}>
 */
export const dirTokens = {
  page: {
    px: { xs: 2, sm: 3, md: 4 },
    py: { xs: 2, sm: 3 },
    maxWidth: 1400,
  },
  section: {
    gap: 3,
    headerGap: 1.5,
  },
  table: {
    rowHeight: 56,
    hoverBg: (theme) => theme.palette.action.hover,
    dividerColor: (theme) => theme.palette.divider,
  },
  actionColumn: {
    width: 120,
    align: "right",
  },
  // Radius consistent with existing Cards (borderRadius: 2)
  radius: 2,
};

export default dirTokens;
